import axios from "axios"

const createGoogleSheetDataAPI = async (url, data) => {
  return await axios.get(url, {
    params: data,
  })
}

export default createGoogleSheetDataAPI
